import React from "react";
import QRCode from "qrcode";
import {classNames, layout, typography, useAsync} from "@variocube/cube-ui";
import {InfoBox} from "./InfoBox";
import {stylesheet} from "typestyle";
import {useLocalization} from "../../i18n";

export function CartOnlineBooking({onlineBookingUrl}: { onlineBookingUrl: string }) {

    const {result} = useAsync(() => QRCode.toDataURL(onlineBookingUrl, {width: 480}), [onlineBookingUrl]);
    const {t} = useLocalization();

    return (
        <div className={classNames(layout.fill, layout.vertical, layout.paddingLarge)}>
            <div className={classNames(layout.vertical, layout.alignCenter)}>
                <div className={classNames(typography.title, layout.paddingMedium)}>
                    {t("BookOnline")}
                </div>
                {result && <img src={result} className={styles.qrCode}/>}
                <div className={classNames(layout.paddingMedium)}>
                    {onlineBookingUrl}
                </div>
                <InfoBox className={styles.infoBox}>
                    <p>{t("BookOnlineInfo")}</p>
                </InfoBox>
            </div>
        </div>
    )
}

const styles = stylesheet({
    qrCode: {
        width: "25%",
    },
    infoBox: {
        background: "rgba(64, 64, 64, 0.67)",
        padding: "0.5em 1em 0.5em 1em",
        width: "30em",
    },
})